import React from 'react';
import {RiderModel, ActionType, RiderStatusType, User, RiderPackageModel, BranchModel, CustomerAddressModel, VehicleDataModel, ManufacturerModel, VehicleModelModel, Riders_PackagesModel, CustomerContactDetailsModel, RiderPackage} from '../../models/superbit-api-models'
import {SubscribersModel} from '../../models/SubscribersModel'
import '../../assets/css/_new-subscriber-popup.css'

import {IDNameDescriptionItem, IDNameDescriptionDictionary, AutocompleteData} from '../../models/Site'
import {SimulatorModel} from '../../models/SimulatorModel'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import RiderPackages from "./_RiderPackages";
import SubscribePopup from './SubscribePopup';


type Props = {
    id:string | undefined;
    actionType: ActionType | undefined;
    ClosePopup: any;
    OpenPayment: any;
    rider?: RiderModel | undefined | null;
    setPopupShow: React.Dispatch<React.SetStateAction<boolean>>;
    setMessege: React.Dispatch<React.SetStateAction<string>>;
    setMessageType: React.Dispatch<React.SetStateAction<string>>;
    setPopUpType: Function;
};
type State = {
    data: RiderModel|null;
    Gender: IDNameDescriptionDictionary;
    IdentityTypes: IDNameDescriptionDictionary;
    VehicleOwnership: IDNameDescriptionDictionary;
    AuthorizedToDriveItems: IDNameDescriptionDictionary;
    InsuranceTypes: IDNameDescriptionDictionary;
    MaritalStatus: IDNameDescriptionDictionary;
    CustomerAgents: IDNameDescriptionDictionary;
    StationUserId: string;
    AgentId: string;
    CustomerHandlers: IDNameDescriptionDictionary;
    SubscriptionStatuses: IDNameDescriptionDictionary;
    Branches: IDNameDescriptionDictionary;
    CarYear: Array<string>;
    SelectedTab: number;
    RiderStatusType: Array<RiderStatusType>;
    licenseNumber: string;
    editMode: boolean;
    packagesList: IDNameDescriptionDictionary;
    Branches2: IDNameDescriptionDictionary;
    allCities: any[];
    streetList: [];
    citiesAutocomplete:Array<AutocompleteData>
    streetAutocomplete:Array<AutocompleteData>
    startDateErrMsg: string;
    endDateErrMsg: string;

    packagesValidationMode: boolean;
    saveLoading: boolean;
    hasUnmachPackages: boolean;
    position: any;
    isDragging: boolean;
    offset: any;
    packegesSum: any;
    showPopUp: boolean;
};
// AuthorizedToDriveItems
 

export class SubscriberUpdatePackagesPopup extends React.Component<Props>
{

    private birthDateRef: React.RefObject<DatePicker>;
    private subscriptionStartDateRef: React.RefObject<DatePicker>;
    private subscriptionEndDateRef: React.RefObject<DatePicker>;
    simulatorModel: SimulatorModel;

    state: State = {
        data:null,
        Gender: new IDNameDescriptionDictionary(),
        IdentityTypes:new IDNameDescriptionDictionary(),
        VehicleOwnership: new IDNameDescriptionDictionary(),
        AuthorizedToDriveItems: new IDNameDescriptionDictionary(),
        InsuranceTypes: new IDNameDescriptionDictionary(),
        MaritalStatus: new IDNameDescriptionDictionary(),
        CustomerAgents: new IDNameDescriptionDictionary(),
        CustomerHandlers: new IDNameDescriptionDictionary(),
        SubscriptionStatuses: new IDNameDescriptionDictionary(),
        Branches: new IDNameDescriptionDictionary(),
        CarYear:[],
        SelectedTab: 2,
        RiderStatusType: [],
        licenseNumber: '',
        editMode: false,
        packagesList: new IDNameDescriptionDictionary(),
        Branches2: new IDNameDescriptionDictionary(),
        StationUserId: '',
        AgentId: '',
        allCities: [],
        streetList: [],
        citiesAutocomplete:[],
        streetAutocomplete:[],
        startDateErrMsg:'',
    endDateErrMsg: '',
    packagesValidationMode:false,
    saveLoading:false,
    hasUnmachPackages: false,
        position: { x: 500, y: 30 },
        isDragging: false,
        offset: { x: 0, y: 0 },
        packegesSum: {num:0,count:0},
        showPopUp: false
      };

    constructor(props:any) {
        super(props);
        this.birthDateRef = React.createRef<DatePicker>(); 
        this.subscriptionStartDateRef = React.createRef<DatePicker>(); 
        this.subscriptionEndDateRef = React.createRef<DatePicker>(); 
        this.simulatorModel = new SimulatorModel();

        this.updatePackages = this.updatePackages.bind(this);
    }
    
    closePopup = () => {
        if(this.state.hasUnmachPackages){
            // this.props.setPopupShow(true);
            // this.props.setMessege("יש לעדכן חבילות ולבצע שמירה");


            this.setState({showPopUp:true});
        }else{
            this.props.ClosePopup();
        }
    }

    updatePackages = (riders:[]) => {
        console.log('updatePackages riders', riders)
        
        let data = this.state.data;
        if(data)
        {
            data.riderPackages = riders.map((x:any)=>{
                if(x.errors && x.errors.customerCostErrorMsg){
                    
                }
                return x.package; 
            })
            this.setState({data:data});
        }
    }

    roundDownNearest10 = (num: number) => {
        return Math.floor(num / 10) * 10;
    }

    calculateDaysBetweenDates = (date1: Date, date2: Date): number => {
        return Math.round((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
    };

    calculatePackegePriceForAgent = (startDate: Date, endDate: Date, agentPrice: number) => {

        if (startDate && endDate) {
            var days = this.calculateDaysBetweenDates(startDate, endDate) + 1;
            var RecommendedCost = agentPrice;
            if (RecommendedCost) {
                if (days != 365) {
                    RecommendedCost = this.roundDownNearest10(RecommendedCost / 365 * days);
                }
                return RecommendedCost;

            }
        }
        return agentPrice;

    }

    packagesValidation = () => {
        let packagesValidation =  !this.state.packagesValidationMode;
        let valid = true;
        this.setState({packagesValidationMode:packagesValidation});
        let data = this.state.data;
        if(data && data.riderPackages){
            console.log('packagesValidation-data.riderPackages', data.riderPackages)
            data.riderPackages.forEach((x:Riders_PackagesModel)=>{
                if(x.activityStatus== 1){
                    valid = false;
                }
            });
            //this.calculatePackegePriceForAgent(data.startDate, data.endDate, x.customerCost)

            data.riderPackages.forEach((x:Riders_PackagesModel)=>{
                if(data){

                    console.log('packagesValidation -this.calculatePackegePriceForAgent(data.startDate as Date, data.endDate as Date, x.agentCost)', this.calculatePackegePriceForAgent(data.startDate as Date, data.endDate as Date, Number(x.agentCost)))
                    console.log('packagesValidation riderPackage x', x)
                }
                if(data && x.customerCost &&  x.agentCost && Number(x.customerCost) < this.calculatePackegePriceForAgent(data.startDate as Date, data.endDate as Date, Number(x.agentCost))){
                    if(!this.isAdmin()){

                        valid = false;
                        console.log('valid', valid)
                    }
                }
            });
        }

        return valid;
    }

    isAdmin = () =>{
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            return loggedUser.role == 0 
        }
        return false;
    }

    packagesValidation2 = () => {
        // 
                var valid = true;
                let data = this.state.data;
                if(data && data.riderPackages && data.riderPackages.length>0){
                    data.riderPackages.forEach((x:Riders_PackagesModel)=>{
                        if(x.activityStatus== 1 ){
                            valid = false;
                        }
                    });
                }
                else{
                    valid = false;
                }
                return valid;
            }


    riderDetailsValidation() {
        
        const startDateValid = this.startDateValidation();
        const endDateValid = this.endDateValidation();
        const packagesValidation = this.packagesValidation();
        const packagesValidation2 = this.packagesValidation2();
        return startDateValid && endDateValid  && packagesValidation && packagesValidation2;
    }

    endDateValidation() {
        var data = this.state.data;
        if (data) {
            if (data.endDate == undefined || data.endDate == null) {
                this.setState({ endDateErrMsg: "* חובה" });
                return false;
            }
            if (data.startDate && data.startDate > data.endDate) {
                this.setState({ endDateErrMsg: "תאריך סיום לא חוקי" });
                return false;
            }
            this.setState({ endDateErrMsg: "" });
            return true;
        }
        return true;
    }

    startDateValidation() {
        var data = this.state.data;
        if (data) {
            if (data.updateStartDate == undefined || data.updateStartDate == null) {
                this.setState({ startDateErrMsg: "* חובה" });
                return false;
            } else {

                if (data.updateStartDate.setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
                    this.setState({ startDateErrMsg: "תאריך תחילה לא חוקי" });
                    return false;
                }
                this.setState({ startDateErrMsg: "" });
                return true;
            }

        }
        return true;
    }

    

    save = async () => {

        if(this.riderDetailsValidation()){
            this.setState({saveLoading:true});
            let finalSum = {num:0,count:0};
            if(this.state && this.state.data 
            && this.state.data.customer
            && this.state.data.riderPackages) {
            const newRiderData: any = {
                "RiderId": this.props.id,
                "UpdateStartDate":this.state.data.updateStartDate,
                "UpdateEndDate":this.state.data.updateEndDate,
                "AdditionNumber":this.state.data.additionNumber,
                "RiderPackages": this.state.data.riderPackages?this.state.data.riderPackages.map((c: any, key: number) => {

                    finalSum.num += Number(c.customerCost);
                    finalSum.count++;
                    return {
                        "RiderPackageId": c.riderPackageId,
                        "CustomerCost": c.customerCost
                    }
                }):[]
                // [
                //     {"RiderPackageId":"70973435-c4b8-4d8b-9ea5-11e6581f3e59","CustomerCost":555},
                //     {"RiderPackageId":"5e8ed4f7-d9d6-49ab-a42a-2f6929614e2b","CustomerCost":666}
                // ]
            };
            console.log(newRiderData, this.state.data.customer);
           
            try {
                // this.props.ClosePopup();
                const response = await new SubscribersModel().riderChangePackages(newRiderData);
                if(response.code==202 || response.code==200){
                    this.setState({hasUnmachPackages: false});

                    if(this.state.packegesSum.count == finalSum.count ){
                        this.props.setPopupShow(true);
                        this.props.setMessege("עדכון  מנוי בוצע בהצלחה");
                        this.setState({hasUnmachPackages: false},()=>{
                            this.closePopup();
                        });
                    } else {

                        this.setState({hasUnmachPackages: false},()=>{
                            this.closePopup();
                        });                        
                        const model = await new SubscribersModel().upsertRider({
                            id: response.val,
                            actionType: this.props.actionType
                        });
                        this.props.setPopupShow(true);
                        this.props.setMessege("עדכון  מנוי בוצע בהצלחה");
                        this.props.OpenPayment(model);
                    }
                }else if(response.code==400){
                    let error = response.errors;
                    let errorMessege = error['Customer.CustomerContactDetails[0].Number'][0];
                    this.props.setPopupShow(true);
                    this.props.setMessege(errorMessege);
                    this.props.setMessageType('שגיאה');
                }else{
                    if(this.state.packegesSum.num != finalSum.num ){
                        this.props.setPopupShow(true);
                        this.props.setMessege(`עדכון המנוי שונה בהצלחה, סכום החבילות שונו מ ${this.state.packegesSum.num} ל ${finalSum.num}`);
                        this.closePopup();

                    }else{
                        this.props.setPopupShow(true);
                        this.props.setMessege("עדכון  מנוי בוצע בהצלחה");
                        this.closePopup();
                    }
                    
                }
                this.setState({saveLoading:false});


                
            } catch (error) {
                console.log('error', error);
                
            }
        }
        }
        
    }
    
    changeCurrentTab = (num: number) => {
        let currentTab = this.state.SelectedTab;
        currentTab += num;
        this.setState({
            SelectedTab: currentTab
        });
    }

    componentDidMount(){
        this.load();
    }

    handleChange (e: any) {}

    async load() {
         
        var CarYear=[];
        for(let i:number=new Date().getFullYear()+1;i >= new Date().getFullYear() - 31; i--){
            CarYear.push(i+"");
        }
        // const model = this.props.rider ? this.props.rider : new RiderModel();// await new SubscribersModel().upsertRider(this.props.id,this.props.actionType);
        const model = await new SubscribersModel().upsertRider({
            id: this.props.id,
            actionType: this.props.actionType
        });
        console.log('model', model);
        // console.log('rider', this.props.rider);

        let licenseNumber = '';
        if (model.vehicle && model.vehicle.licenseNumber) {
            licenseNumber = model.vehicle.licenseNumber;
        }


        if (this.props.id && this.props.id != '') {
            this.setState({
                editMode: true
            });
        } else {
            model.customer.dateOfBirth = new Date();
        }
        
        if (model && model.customer && model.customer.customerAddresses && model.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            model.customer.customerAddresses.push(address);
        }

        const allCities = await this.simulatorModel.getCitiesAutocomplete()
        this.setState({
            data : model,
            Gender: await this.simulatorModel.getGenderTypes(),
            IdentityTypes: await this.simulatorModel.getIdentityTypes(),
            VehicleOwnership: await this.simulatorModel.getVehicleOwnership(),
            AuthorizedToDriveItems: await this.simulatorModel.getAuthorizedToDriveItems(),
            InsuranceTypes: await this.simulatorModel.getInsuranceTypes(),
            MaritalStatus: await this.simulatorModel.getMaritalStatus(),
            CarYear: CarYear,
            SelectedTab: 2,
            RiderStatusType: [],
            CustomerHandlers: await this.normalizeHandlers(),
            CustomerAgents: await this.normalizeAgents(),
            Branches: await this.buildTreeSelectData(),
            selectedBranch: null,
            licenseNumber: licenseNumber,
            SubscriptionStatuses: [
                {
                    description: 'פעיל',
                    name: 'פעיל',
                    id: 0
                },
                {
                    description: 'מוקפא',
                    name: 'מוקפא',
                    id: 1
                },
                {
                    description: 'ביטול',
                    name: 'ביטול',
                    id: 1
                }
            ],
            packagesList: this.buildPackagesList(model.packages),
            Branches2: await this.buildBranchesSelectData(),
            allCities: allCities,
            streetList: [],
            citiesAutocomplete: allCities,
            streetAutocomplete: []
        });

        let oldPackeges = {num:0,count:0}
        if (model && model.riderPackages) {
            model.riderPackages.forEach((p: any) => {
                oldPackeges.num += p.customerCost;
                oldPackeges.count++;
            });
        }
        this.setState({packegesSum: oldPackeges});

        this.checkUnmachPackages(model);

        console.log('Edit', this.state)
    }

    checkUnmachPackages = (model: RiderModel) => {
        if (model && model.riderPackages) {
            model.riderPackages.forEach((p: any) => {
                if (p.activityStatus == 1) {
                    this.setState({hasUnmachPackages: true});
                }
            });
        }
    }

    
    async getBranchesTree() {
        const allBranches = await this.simulatorModel.getBranches();
        const branchesTree = allBranches.filter((b: any) => b.parentId === null);
        branchesTree.forEach((rootBranch: any) => {
            rootBranch.children = this.getSubBranches(rootBranch, allBranches);
        });
        
        console.log('branchesTree', branchesTree);
    
        return branchesTree;
    }

    getSubBranches = (branch: any, branches: any[]) => {
        const subBranches = branches.filter((b: any) => b.parentId === branch.id);
        if (subBranches && subBranches.length > 0) {
            subBranches.forEach((b: any) => {
                b.children = this.getSubBranches(b, branches);
            })
        }
        return subBranches;
    }

    arangeBranchesIntoTree = (bList: any[]) =>{
        bList.forEach((branch:any, index: number)=>{
            if (branch.parentId !== null) {
                const parentItem = bList.find((i: any) => i && i.id && i.id === branch.parentId);
                if (parentItem) {
                    const child = JSON.parse(JSON.stringify(branch));
                    if (parentItem.children) {
                        parentItem.children.push(child);
                    } else {
                        parentItem.children = [child];
                    }
                }
                delete bList[index];
            }
        })
    }

    getTreeItem = (branch: any, isParent = true) => {
        if (branch.children) {
            isParent = true;
        }
        const item = {
            label: branch.name,
            value: branch.id,
            isParent: isParent ? true : false,
            // disabled: isParent ? true : false,
            className: 'hidden-checkbox',
            children: []
        }
        if (branch.children && branch.children.length > 0) {
            branch.children.forEach((c: any) => {
                const newItem = this.getTreeItem(c);
                item.children.push(newItem as never);
            })
        }
        return item;
    }

    onBranchChange = (e:any) => {
        const branches = this.state.Branches as any;
        if (e.checked && !e.isParent) {
            this.setState({
                selectedBranch: e.value
            });
        } else {
            this.setState({
                selectedBranch: null
            });
        }

        branches.forEach((branch: any) => {
            branch.checked = false;
            if (branch.children) {
                branch.children.forEach((child: any) => {
                    if (child.value === e.value && e.checked ) {
                        child.checked = true;
                    } else {
                        child.checked = false
                    }
                });
            }
        });
        
        this.setState({
            Branches: branches
        })
        console.log('onBranchChange', e)
    }

    onBranchToggle = (e:any) => {
        // console.log('onBranchToggle', e);
    }
    
    
    buildTreeSelectData = async() => {
        const allBranches = await this.simulatorModel.getBranches();
        const rootItems = allBranches.filter((b: any) => b.parentId === null);
        const subBranches = allBranches.filter((b: any) => b.parentId != null);
        const branchesTree: any = [];
        rootItems.forEach((bItem: any) => {
        const branch = this.buildBranchData(bItem.id, allBranches);
        branchesTree.push(branch);
        });
        
        // this.setState({
        //     Branches: branchesTree
        // });
        console.log('branchesTree', subBranches, branchesTree);
        return branchesTree;
    }

    buildBranchData = (branchId: string | null, allBranches: any[]) =>{
        const branchData = allBranches.find((b: any) => b.id === branchId);
        const branch: any = {
        label: branchData.name,
        value: branchData.id,
        tagClassName: ''
        }
        const subBranches: any[] =  [];
        const items = allBranches.filter((b: any) => b.parentId === branchId);
        items.forEach((item: any) => {
        const branchSub = this.buildBranchData(item.id, allBranches);
        subBranches.push(branchSub);
        });
        branch.children = subBranches;
        if (branchData.users && branchData.users.length > 0) {
        branchData.users.forEach((user: any) => {
            branch.children.push({
                value: user.value,
                label: user.text
            })
        })
        }
        return branch;
    }
    
    onTreeSelectChange = (currentNode: any, selectedNodes: any[]) => {
        console.log(currentNode, selectedNodes);
    }

    async normalizeHandlers () {
        const customerCardHandlers = await this.simulatorModel.getCustomerCardHandlers();
        const returnDictionary: any = {}
        customerCardHandlers.map((c: User, key: number) => {
            const item: any = {};
            item.description  = c.fullName;
            item.name  = c.fullName;
            item.id  = c.id;
            returnDictionary[key] = item;
        });
        return returnDictionary;
    }

    async normalizeAgents () {
        const customerCardHandlers = await this.simulatorModel.getCustomerCardAgents();
        const agents: IDNameDescriptionItem[] = [];
        agents.push({
            description: 'סוכן',
            name: '',
            id: 0
        })
        customerCardHandlers.map((a: any) => {
            agents.push({
                description: a.name,
                name: a.name,
                id: a.id
            })
        });
        
        return agents as IDNameDescriptionItem[];
    }

    buildPackagesList = (packages:any) => {
        const newList: any = [{
            description: 'בחר',
            name: '',
            id: 0,
            package: null
        }];
        packages.forEach((p: any) => {
            newList.push({
                description: p.name,
                name: p.name,
                id: p.id
            })
        });
        console.log('buildPackagesList', newList)
        return newList as IDNameDescriptionDictionary;        
    }

    async normalizeBranches() {
        const branchesList = await this.simulatorModel.getBranches();
        // return customerCardHandlers.map((a: any) => {
        //     return {
        //         description: a.name,
        //         name: a.name,
        //         id: a.id
        //     }
        // }) as IDNameDescriptionItem[];
    }

    setStateData = async (name:string, value:any) => {
        let stateData = this.state.data;
        if (!stateData) {
            stateData = new RiderModel();
        }
        if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length == 0) {
            const address: CustomerAddressModel = new CustomerAddressModel({
                city: '',
                street: '',
                houseNumber: undefined,
                apartmentNumber: undefined,
                postalCode: undefined,
                mailbox: undefined
            });
            stateData.customer.customerAddresses.push(address);
        }
        if (stateData.customer) {
            if (!stateData.customer.customerContactDetails) {
                stateData.customer.customerContactDetails = [];
            }
            if (stateData.customer.customerContactDetails.length == 0) {
                const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                    id: '00000000-0000-0000-0000-000000000000',
                    emailAddress: '',
                    number: ''
                })
                stateData.customer.customerContactDetails.push(customerContactDetail);
            }
        }
        switch (name) {
            // customer
            case 'identifier': {
                if (this.isValidIsraeliID(value)) {
                    const customerData = await this.simulatorModel.getCustomerDetailsById(value);
                    console.log('customerData', customerData);
                    if (customerData && customerData.customer) {
                        if (stateData && stateData.customer) {
                            stateData.customer.identityType = customerData.customer.identityType;
                            stateData.customer.firstName  = customerData.customer.firstName;
                            stateData.customer.lastName  = customerData.customer.lastName;

                            const bDate = new Date(customerData.customer.dateOfBirth.replace('T', ' '));
                            stateData.customer.dateOfBirth  = bDate;

                            stateData.customer.gender  = customerData.customer.gender;

                            stateData.customer.customerContactDetails = customerData.customer.customerContactDetails;
                            stateData.customer.customerAddresses = customerData.customer.customerAddresses;

                        }
                    }
                }
                if (stateData && stateData.customer) {
                    stateData.customer.identifier = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'identityType': {
                if (stateData && stateData.customer) {
                    stateData.customer.identityType = value;
                }
                break;
            }
            case 'firstName':{
                if (stateData && stateData.customer) {
                    stateData.customer.firstName = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'lastName':{
                if (stateData && stateData.customer) {
                    stateData.customer.lastName = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'dateOfBirth':{
                if (stateData && stateData.customer) {
                    stateData.customer.dateOfBirth = value as Date;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'gender': {
                if (stateData && stateData.customer) {
                    stateData.customer.gender = value;
                }
                // this.state.data.customer.dateOfBirth
                break;
            }
            case 'telNumber': {
                if (stateData.customer) {
                    if (!stateData.customer.customerContactDetails) {
                        stateData.customer.customerContactDetails = [];
                    }
                    if (stateData.customer.customerContactDetails.length == 0) {
                        const customerContactDetail: CustomerContactDetailsModel = new CustomerContactDetailsModel({
                            id: '',
                            emailAddress: '',
                            number: ''
                        })
                        stateData.customer.customerContactDetails.push(customerContactDetail);
                    }
                    stateData.customer.customerContactDetails[0].number = value;
                }
                
                break;
            }
            case 'emailAddress': {
                if (stateData && stateData.customer && stateData.customer.customerContactDetails  && stateData.customer.customerContactDetails.length > 0) {
                    stateData.customer.customerContactDetails[0].emailAddress = value;
                }
                break;
            }
            // customer address
            case 'city': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].city = value;
                }
                break;
            }
            case 'street': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].street = value;
                }
                break;
            }
            case 'houseNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].houseNumber = value;
                }
                break;
            }
            case 'apartmentNumber': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].apartmentNumber = value;
                }
                break;
            }
            case 'postalCode': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].postalCode = value;
                }
                break;
            }
            case 'mailbox': {
                if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
                    stateData.customer.customerAddresses[0].mailbox = value;
                }
                break;
            }
            // vehicle
            case 'licenseNumber': {
                if (stateData && stateData.vehicle && stateData.vehicle.licenseNumber) {
                    stateData.vehicle.licenseNumber = value;
                }

                break;
            }
            case 'stationUserId':{
                // if (stateData && stateData.stationUserId) {
                //     stateData.stationUserId = value;
                // }
                this.setState({
                    StationUserId: value
                });
                break;
            }
            case 'agentId':{
                this.setState({
                    AgentId: value
                });
                break;
            }
            default:
                (stateData as any)[name] = value
                break;
        }
        this.setState({data: stateData});
    }

    onCityChange = (city: string) => {
        let stateData = this.state.data;
        const cities = this.state.allCities.filter(
            (m: any) => {
                return m.text!=null && m.text.indexOf(city)>-1
            }
        );
        this.setState({
            citiesAutocomplete: cities
        });
        if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].city = city;
            this.setState({data: stateData});
            console.log('onCityChange', city, this.state.citiesAutocomplete, stateData.customer.customerAddresses[0].city)
        }
    }
    
    onCitySelect = (city: string) => {
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].city = city;
            this.setState({data: stateData});

            const streetAutocomplete = this.simulatorModel.getStreetsAutocomplete(city);
            this.setState({streetList: streetAutocomplete});
        }
    }
    
    onStreetChange = (street: string) => {
        const streets = this.state.streetList.filter(
            (m: any) => {
                return m.text!=null && m.text.indexOf(street)>-1
            }
        );
        this.setState({
            streetAutocomplete: streets
        });
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].street = street;
            this.setState({data: stateData});
        }
    }
    onStreetSelect = (street: string) => {
        let stateData = this.state.data;
        if (stateData && stateData.customer && stateData.customer.customerAddresses  && stateData.customer.customerAddresses.length > 0) {
            stateData.customer.customerAddresses[0].street = street;
            this.setState({data: stateData});
        }
    }


    getVehicleDetailsKeyPress= async(event:any)=>{
        console.log(event.key);
        if (event.key === 'Enter' || event.key === 'Tab') {
            const licenseNumber = event.currentTarget.value;
            this.getVehicleDetails(licenseNumber);
            this.setStateData('licenseNumber', licenseNumber)
        } else {
            // this.setState({licenseNumber: event.target.value});
        }
    }
    
    getVehicleDetails= async(licenseNumber: string)=>{
        var data = await this.simulatorModel.getVehicleDetailsByLicenseNumber(licenseNumber);

        let riderData = this.state.data;
        if (!riderData) {
            riderData = new RiderModel();
        }
        if (!riderData.vehicle) {
            riderData.vehicle = new VehicleDataModel();
        }
        
        console.log(riderData.vehicle);

        
        if (data && data.LeviItzhak!=null) {
            if(data.LeviItzhak.manufacturer!=null){
                if (!riderData.vehicle.manufacturer) {
                    riderData.vehicle.manufacturer = new ManufacturerModel();
                }
                riderData.vehicle.manufacturer.name = data.LeviItzhak.manufacturer.label;
                riderData.vehicle.manufacturer.id = data.LeviItzhak.manufacturer.val;
                
            }
            if(data.LeviItzhak.vehicleModel!=null) {
                if(!riderData.vehicle.vehicleModel) {
                    riderData.vehicle.vehicleModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleModel.name = data.LeviItzhak.vehicleModel.label;
                riderData.vehicle.vehicleModel.id = data.LeviItzhak.vehicleModel.val;
            }
            if(data.LeviItzhak.vehicleSubModel!=null) {
                if(!riderData.vehicle.vehicleSubModel) {
                    riderData.vehicle.vehicleSubModel = new VehicleModelModel();
                }
                riderData.vehicle.vehicleSubModelId = data.LeviItzhak.vehicleSubModel.val;
                riderData.vehicle.vehicleSubModel.name = data.LeviItzhak.vehicleSubModel.label;
                riderData.vehicle.modelCode = data.LeviItzhak.vehicleSubModel.code;
            }

            riderData.vehicle.vehicleOwnership = data.LeviItzhak.vehicleOwnership;
            riderData.vehicle.carYear = data.LeviItzhak.carYear;
            riderData.vehicle.entryToRoadDate = data.LeviItzhak.entryToRoad;
        }
        this.setState({
            data: riderData
        })
    }

    onSelectPackage (name:string, value:any) {
        console.log(name, value);
        const riderData = this.state.data;
        if (riderData && riderData.packages) {
            const selectedPackage = riderData.packages.find((p: any)=> p.id === value);
            if (selectedPackage) {
                this.addRiderPackage(selectedPackage);
            }
        }
    }

    addRiderPackage = (selectedPackage: any) => {
        const data = this.state.data ? this.state.data : new RiderModel();
        if (!data.riderPackages) {
            data.riderPackages = [];
        }

        const newRiderPackage = new Riders_PackagesModel();
        newRiderPackage.riderId = data.id;
        newRiderPackage.riderPackageId = selectedPackage.id;
        newRiderPackage.riderPackage = selectedPackage;
        newRiderPackage.agentCost = selectedPackage.agentCost;
        newRiderPackage.customerCost = selectedPackage.recommendedCost;
        
        data.riderPackages.push(newRiderPackage);

        this.setState({data: data});
    }

    removeRiderPackage = (packageId: string) => {
        
        const data = this.state.data ? this.state.data : new RiderModel();
        if (data.riderPackages) {
            const selectedPackageIndex = data.riderPackages.findIndex((p: any) => p && p.riderPackageId === packageId);
            if (selectedPackageIndex >= 0) {
                // console.log('package to remove:', selectedPackage);
                delete data.riderPackages[selectedPackageIndex];
                this.setState({
                    data: data
                });
            }
        }
    }

    
    async buildBranchesSelectData () {
        const branches = await this.getBranchesTree();
        let branchesSelectData: any[] = [];

        branches.forEach((b: any) => {
            const items = this.buildBranchSelectItems(b, '');
            branchesSelectData = Object.assign(branchesSelectData, items);
        });
        const newList = new IDNameDescriptionDictionary();
        const bList = this.buildSelectDataObject(branchesSelectData);
        newList['0'] = {
            description: 'עמדה',
            name: '',
            id: 0
        }
        bList.forEach((b, index)=> {
            if (b && b.id) {
                newList[b.id] = b;
            }
        });
        console.log('newList', newList)
        return newList;
    }

    buildBranchSelectItems = (branch: any, branchName: string = '') => {
      const b = {
              label: "VP Accounting",
              tagClassName: "special",
      }
      if (branchName !== '') {
          branchName += '/';
      }
      branchName += branch.name;
      let items: any[] = [];
      if (branch.users && branch.users.length > 0) {
          branch.users.forEach((user: any) => {
              items.push({
                  value: user.value,
                  text: branchName + '/' + user.text
              })
          })
      }
      if (branch.children && branch.children.length > 0) {
          branch.children.forEach((child: any) => {
              const childItems = this.buildBranchSelectItems(child, branchName);
              if (childItems && childItems.length > 0) {
                  items = Object.assign(items, childItems);
              }
          })
      }
  
      return items;
    } 

    buildSelectDataObject = (dataList: any[]) => {
        return dataList.map((a: any) => {
            return {
                description: a.text,
                name: a.text,
                id: a.value
            }
        }) as IDNameDescriptionItem[];
    }
  
    isValidIsraeliID = (id: string) => {
        var id = String(id).trim();
        if (id.length > 9 || id.length < 5 || isNaN(parseInt(id))) return false;
    
        // Pad string with zeros up to 9 digits
          id = id.length < 9 ? ("00000000" + id).slice(-9) : id;
    
          return Array
                .from(id, Number)
                  .reduce((counter, digit, i) => {
                    const step = digit * ((i % 2) + 1);
                            return counter + (step > 9 ? step - 9 : step);
                        }) % 10 === 0;
    }

    handleMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
            this.setState({ isDragging: true, offset: { x: e.clientX - this.state.position.x, y: e.clientY - this.state.position.y } });
    };
    
    handleMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
        if (this.state.isDragging) {
            this.setState({ position: { x: e.clientX - this.state.offset.x, y: e.clientY - this.state.offset.y } });
        }
    };
    
    handleMouseUp = (): void => {
        this.setState({ isDragging: false });
    };
    
    showHidePopup = (show: boolean) => {
        this.setState({ showPopUp: show });
    }
      
    render() {
      return (   <>
      {this.state.data!=null?(
        <>
        <div className="popup-wrapper">
        <section className="popup-window new-subscriber rtl"
        style={{ position: 'absolute', top: this.state.position.y, left: this.state.position.x }}
        >
            {this.state.hasUnmachPackages === false && <div className="close-icon pointer" onClick={(e:any)=>this.closePopup()}></div>}
            <div className="popup-content">
                <div className="popup-header"
                style={{ cursor: this.state.isDragging ? 'grabbing' : 'grab', }}
                onMouseDown={this.handleMouseDown}
                onMouseMove={this.handleMouseMove}
                onMouseUp={this.handleMouseUp}
                onMouseLeave={this.handleMouseUp}
                >
                    <div className="popup-title">
                פרטי תשלום
                    </div>
                </div>

                {this.state.showPopUp && <SubscribePopup
                    messageContent={"לא נבחרו חבילות , מנוי לא  בתוקף, האם להמשיך? "}
                    ShowHidePopup={this.showHidePopup}
                    ClosePopup={()=>this.showHidePopup(false)}
                    OnApprove={this.props.setPopUpType}
                />}
                <div className="popup-body">
                    <div className="tab-contents">
                        <div className={'tab-content tab-content-2 ' + (this.state.SelectedTab === 2 ? 'selected' : '')}>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' מנוי
                                        </div>
                                        <div className="value">
                                        {this.state.data.subscriberNumber!=null ? this.state.data.subscriberNumber : ""}
                                        {this.state.data.additionNumber != null ? "/"+(this.state.data.additionNumber>10?this.state.data.additionNumber:"0"+this.state.data.additionNumber) : ""}
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            תאריך עדכון
                                        </div>
                                        <div className="value">
                                            <DatePicker
                                                ref={this.subscriptionStartDateRef}
                                                selected={
                                                    this.state.data!=null && 
                                                    this.state.data.updateStartDate != null ? this.state.data.updateStartDate : this.state.data.startDate}
                                                onSelect={(e:any) => this.setStateData("updateStartDate", e)}
                                                onChange={(e:any) =>  this.setStateData("updateStartDate", e)}
                                                dateFormat='dd/MM/yyyy'
                                                minDate={this.state.data.startDate}
                                            />
                                            <div className="icon small-icon calendar pointer"></div>
                                        </div>
                                        <div className='error-message2'>{this.state.startDateErrMsg}</div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            תאריך סיום עדכון
                                        </div>
                                        <div className="value">
                                            {/* <DatePicker
                                                ref={this.subscriptionEndDateRef}
                                                selected={
                                                    this.state.data!=null && 
                                                    this.state.data.updateEndDate != null ? this.state.data.updateEndDate : new Date()}
                                                onSelect={(e:any) => this.setStateData("updateEndDate", e)}
                                                onChange={(e:any) =>  this.setStateData("updateEndDate", e)}
                                                dateFormat='dd/MM/yyyy'
                                            /> */}
                                            <div>{this.state.data && this.state.data.updateEndDate 
    ? this.state.data.updateEndDate instanceof Date 
      ? new Date(this.state.data.updateEndDate).toLocaleDateString('en-GB')
      : this.state.data.updateEndDate
    : ""}</div>
                                            <div className="icon small-icon calendar pointer"></div>
                                        </div>
                                        <div className='error-message2'>{this.state.endDateErrMsg}</div>
                                    </div>
                                </div>
                            </div>
                            
                            <RiderPackages riderId={this.state.data.id} vehicle={this.state.data.vehicle} riderPackages={this.state.data.riderPackages} 
                            packages={this.state.data.packages} startDate={this.state.data.updateStartDate}  endDate={this.state.data.updateEndDate} 
                            updatePackages={this.updatePackages} doValidate={this.state.packagesValidationMode} />
                        </div>
                    </div>
                </div>
                <div className="popup-footer">
                    <button className="button white blue-border" onClick={(e:any)=>this.closePopup()}>
                        ביטול
                    </button>
                    <div style={{display: 'flex'}}>
                    <button className="button white blue-border save" onClick={(e:any)=>this.save()} disabled={this.state.saveLoading ? true : false}>
                        שמור
                    </button>
                    <img src={require("../../assets/images/loading.gif")} className={this.state.saveLoading ? "loadingGif" : "hide"} />
                    </div>
                </div>
            </div>
        </section>
    </div>
        </>
      ):""}
      </>
        
        
        
      );
    }
  }
